
import http from './request'

export async function wechatConfig(data = {}) {
    return http({
        url: '/insurance/user/wechatConfigByType/4',
        params: data,
        loading: false
    });
}

// 获取个人信息
export async function userInfoServer(data = {}) {
    return http({
        url: 'user/home',
        params: data,
        method: 'GET',
        loading: true
    })
}

// 用户发表的动态列表
export async function dynamicListServer(data = {}) {
    return http({
        url: 'user/posts',
        params: data,
        method: 'GET',
        loading: false
    })
}

// 用户收藏的动态列表
export async function collectListServer(data = {}) {
    return http({
        url: 'user/collect-posts',
        params: data,
        method: 'GET',
        loading: false
    })
}

// 用户打卡过的攀岩馆列表
export async function userHallListServer(data = {}) {
    return http({
        url: 'user/gym-list',
        params: data,
        method: 'GET',
        loading: false
    })
}

// 用户攀岩馆数据统计
export async function userHallDataServer(data = {}) {
    return http({
        url: 'user/gym-data',
        params: data,
        method: 'GET',
        loading: true
    })
}

// 用户攀岩场数据排名
export async function userFieldDataServer(data = {}) {
    return http({
        url: 'user/field-data-rank',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 用户攀岩场数据
export async function userFieldDataDetialServer(data = {}) {
    return http({
        url: 'user/field-data',
        params: data,
        method: 'GET',
        loading: true
    })
}

// 关注某个人
export async function recommendUserServer(data = {}) {
    return http({
        url: 'forum/post/recommend-user',
        data,
        loading: true,
    });
}

// 用户Top10打卡线路列表
export async function top10LineServer(data = {}) {
    return http({
        url: 'user/top-line',
        data,
        loading: true,
    });
}

// 用户各线路类型的最高级别
export async function userMaxLineServer(data = {}) {
    return http({
        url: 'user/max-level',
        data,
        loading: true,
    });
}

// 获取用户判断级别
export async function feildJudgeLevelServer(data = {}) {
    return http({
        url: 'user/judge-level',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 拉黑某人
export async function blackUserServer(data = {}) {
    return http({
        url: 'forum/post/black-user',
        data,
        loading: true,
    });
}
